module.exports = __webpack_public_path__ + "static/media/59.a821f591.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/59.svg
// module id = 189
// module chunks = 0